import { pricingAPI } from "services/swagger-api";
import { MainBorrowerPricingState } from "../../types";
import { MainBorrowerPricingSyncActions } from "../types";
import { ComparateurPricingStatus } from "api/pricing";

export const onContractFunnelFeeUpdate = async (
  contractFunnelId: string,
  contractIdentifier: string,
  funnelHash: string,
  actions: MainBorrowerPricingSyncActions,
  getState: () => MainBorrowerPricingState
): Promise<void> => {
  try {
    const { contractFunnels } = getState()
    const funnel = contractFunnels.find(f => f.hash === funnelHash)

    if (!funnel || !funnel.hash) {
      console.warn('Contract funnel not found or missing hash', { contractFunnelId, contractIdentifier, funnelHash })
      return
    }

    // Mettre le funnel en état Pending pour montrer le loading
    actions.setFunnelPricingPending({ contractFunnelId, contractIdentifier, funnelHash: funnel.hash })

    // Construire le body avec les fees actuels du funnel
    const fees = funnel.fees?.map(fee => ({
      code: fee.code,
      value: fee.value,
    })) || []

    // Appeler le endpoint PUT /contract-funnel/{oldHash}
    await pricingAPI.customizeBorrowerContractFunnelV2({
      oldHash: funnel.hash,
      customBorrowerContractFunnelCommandDto: { fees }
    })

    // Le prix sera mis à jour via SignalR (UPDATE_FUNNEL_PRICING)
  } catch (error) {
    actions.setError(error instanceof Error ? error.message : 'Une erreur est survenue lors de la mise à jour du funnel')
  }
}
